import { ChevronDownIcon } from "lucide-react";

import { cn } from "@/lib/utils";

export function PillSelect({
  className,
  active,
  children,
  ...props
}: React.ComponentProps<"select"> & { active?: boolean }) {
  return (
    <div className="relative inline-flex">
      <select
        className={cn(
          "h-9 appearance-none rounded-full border py-1 pr-8 pl-3.5 text-sm font-medium outline-none transition-colors focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50",
          active
            ? "border-transparent bg-primary text-primary-foreground"
            : "border-border bg-background hover:bg-muted",
          className
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDownIcon
        className={cn(
          "pointer-events-none absolute top-1/2 right-2.5 size-3.5 -translate-y-1/2",
          active ? "text-primary-foreground/80" : "text-muted-foreground"
        )}
      />
    </div>
  );
}
